import React from 'react';

import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import StepsChart from 'components/shared/StepsChart/StepsChart';

import { getCurrentStep, getStepsLeft } from '../../lib/helpers';

import FormDetails from './components/FormDetails';
import FormComponents from './components/FormComponents';

const Review = ({ currentBreadcrumb, formTypes }) => {
  const { breadCrumbs } = useFormBuilderContext();
  const currentBreadcrumbStep = getCurrentStep(breadCrumbs, currentBreadcrumb);
  const getBreadcrumbsLeft = getStepsLeft(breadCrumbs, currentBreadcrumb);
  const chartData = [
    { name: 'completed', value: currentBreadcrumbStep },
    { name: 'not-completed', value: getBreadcrumbsLeft }
  ];
  return (
    <div>
      <StepsChart
        chartData={chartData}
        title="Form review"
        description="Have a final check of your form before confirming."
        innerText={`${currentBreadcrumbStep}/${currentBreadcrumbStep + getBreadcrumbsLeft}`}
      />
      <div className="p-4">
        <FormDetails formTypes={formTypes} />
        <FormComponents />
      </div>
    </div>
  );
};

export default Review;
